"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var leaf = {
  50: '#e0ffcc',
  100: '#cafcac',
  200: '#abf67e',
  300: '#8eee56',
  400: '#75e137',
  500: '#5ed020',
  600: '#49b911',
  700: '#379d07',
  800: '#277c02',
  900: '#195900',
  A100: '#f3ffeb',
  A200: '#9ff566',
  A400: '#83f82a',
  A700: '#43c70f'
};
exports["default"] = leaf;